<template>
    <div class="recruitment">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="recruitment"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- <el-drawer title="高级搜索"
                 :visible.sync="drawerVisible"
                 size="320px"
                 class="drawerCont"
                 ref="drawer"
                 :wrapperClosable="false">
        <el-scrollbar class="scrollbar">
          <el-form :model="searchForm"
                   class="drawerForm"
                   label-width="120">
            <el-form-item label="招聘职位"
                          size="small">
              <el-select v-model="searchForm.position"
                         clearable
                         placeholder="请选择职位"
                         size="small">
                <el-option v-for="item in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本号"
                          size="small">
              <el-input clearable
                        placeholder="请输入版本号"
                        maxlength="50"
                        size="small"
                        v-model="searchForm.version"
                        @keyup.enter.native="recruitment(1)">
              </el-input>
            </el-form-item>
            <el-form-item label="发布日期"
                          size="small">
              <el-date-picker v-model="searchForm.publish_time"
                              type="date"
                              placeholder="发布日期"
                              size="small"
                              value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-scrollbar>
        <div class="drawer-footer">
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="recruitment(1)">
            查询
          </el-button>
          <el-button type="danger"
                     icon="el-icon-circle-close"
                     size="small"
                     @click="clean">
            清空
          </el-button>
        </div>
      </el-drawer> -->
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="招聘职位" size="mini">
                            <el-select
                                v-model="searchForm.role_id"
                                clearable
                                placeholder="请选择招聘职位"
                                size="mini"
                                @change="recruitment"
                            >
                                <el-option
                                    v-for="item in roleList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="招聘类型" size="mini">
                            <el-select
                                v-model="searchForm.type"
                                clearable
                                placeholder="请选择招聘类型"
                                size="mini"
                                @change="recruitment"
                            >
                                <el-option
                                    v-for="item in recruitList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="到岗日期" size="mini">
                            <el-date-picker
                                v-model="searchForm.req_work_time"
                                type="date"
                                placeholder="请选择到岗日期"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="recruitment"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="recruitment(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth">
                            <el-button
                                :key="item.id"
                                type="primary"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                    </div>
                    <div v-else></div>
                </div>
                <!-- <el-button class="el-icon-s-fold searchDrawer"
                   type="text"
                   size="mini"
                   @click="drawerVisible = true">高级搜索</el-button> -->
            </div>
            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table
                    :data="tableData"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                >
                    <!-- <el-table-column width="60" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{
                                (paginationData.page - 1) *
                                    paginationData["per-page"] +
                                scope.$index +
                                1
                            }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="部门"
                        property="depart_name"
                        align="left"
                        min-width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="招聘职位"
                        property="role_name"
                        align="left"
                    >
                    </el-table-column>

                    <el-table-column
                        label="招聘类型"
                        property="type_cn"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="招聘人数"
                        property="people"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="工作年限"
                        property="experience"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="到岗日期"
                        property="req_work_time"
                        align="left"
                        min-width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="面试人数"
                        property="interview_num"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="已入职人数"
                        property="recruits_num"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="跟进人"
                        property="follow_user_name"
                        align="left"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column label="当前状态" align="left" header-align="center" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 5
                                        ? 'warning'
                                        : scope.row.status == 10
                                        ? 'success'
                                        : scope.row.status == 20 ||
                                          scope.row.status == 99
                                        ? 'danger'
                                        : 'info'
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        align="left"
                        header-align="left"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        width="140"
                        property="create_time"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
        </div>
        <importPublic
            :importVisible.sync="importVisible"
            :parentFuncName="'recruitment'"
            :methodName="'recruitmentImport'"
            :temSrc="'/v1/recruitment/download-tpl'"
            :title="'招聘批量导入'"
        ></importPublic>
        <add :addVisible.sync="addVisible"></add>
        <edit
            :editVisible.sync="editVisible"
            :tableItem.sync="tableItem"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
        <interviewAdd
            :addVisible.sync="interviewAddVisible"
            :tableItem="tableItem"
        ></interviewAdd>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import importPublic from "@/comon/components/importPublic";
import pagination from "@/comon/components/pagination";
import add from "./recruitList/add";
import edit from "./recruitList/edit";
import detail from "./recruitList/detail";
import popConfirm from "@/comon/components/popConfirm";
export default {
    mixins: [tableMixin],
    data() {
        return {
            searchForm: {
                title: "",
                version: "",
                publish_time: "",
                status: "",
            },
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            statusList: [],
            roleList: [],
            recruitList: [],
            tableItem: {},
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            drawerVisible: false,
            importVisible: false,
            interviewAddVisible: false,
        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                title: "",
                version: "",
                publish_time: "",
            };
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取table
         */
        recruitment(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .recruitment(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        this.$nextTick(() => {
                            this.resetTabActivePosition(this.$refs.tabs.$el);
                        });
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                    }
                });
        },
        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.recruitment();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "编辑") {
                this.editVisible = true;
                this.tableItem = row;
            } else if (item.name == "删除") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }) 
                    .then(() =>*/
                oaApi.recruitment({}, "delete", row.id).then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success(`${item.name}成功`);
                            this.recruitment();
                        }
                    }
                });
                /* )
                    .catch(() => {
                        this.$message.info("已取消操作");
                    }); */
            } else if (item.name == "查看") {
                this.detailVisible = true;
                this.tableItem = row;
            } else if (item.name == "提交") {
                this.updateStatus(item, row.id, 2);
            } else if (item.name == "确认") {
                this.updateStatus(item, row.id, 5);
            } else if (item.name == "取消") {
                this.updateStatus(item, row.id, 99);
            } else if (item.name == "面试") {
                this.interviewAddVisible = true;
                this.tableItem = row;
                //console.log(this.tableItem)
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        getRoleList() {
            oaApi.roleSelect({}, "get").then((res) => {
                if (res) {
                    this.roleList = res.data;
                }
            });
        },
        export() {
            oaApi
                .recruitmentExport(
                    {
                        ...this.searchForm,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        window.open(res.data.url);
                    }
                });
        },
        import() {
            this.importVisible = true;
        },
        recruitmentRecruit() {
            oaApi.recruitmentRecruit({}, "get").then((res) => {
                if (res) {
                    this.recruitList = res.data;
                }
            });
        },
        /**
         * 修改招聘的状态
         */
        updateStatus(item, id, status) {
            /* this.$confirm(`确定${item.name}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => { */
            oaApi.recruitmentUpdateStatus({ id, status }, "get").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(`${item.name}成功`);
                        this.recruitment();
                    }
                }
            });
            /* })
                .catch(() => {
                    this.$message.info("已取消操作");
                }); */
        },
    },
    mounted() {
        this.recruitment();
        this.getRoleList();
        this.recruitmentRecruit();
    },
    components: {
        pagination: pagination,
        importPublic: importPublic,
        popConfirm: popConfirm,
        add: add,
        edit: edit,
        detail: detail,
        interviewAdd: () => import("./interviewList/add"),
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        staffList() {
            return this.$store.state.index.staffList;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_select");
        },
    },
};
</script>
<style lang="scss">
.recruitment {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;

    .tableCont {
        width: 100%;
        height: 100%;
        border-left: 1px solid #eee;
        padding: 0 20px;
        box-sizing: border-box;
        .tabCont {
            .el-tabs--border-card {
                .el-tabs__item {
                    height: 32px;
                    line-height: 32px;
                    .label {
                        i {
                            margin-right: 3px;
                        }
                    }
                }
            }
        }
        .table {
            width: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
            .el-table__fixed-header-wrapper {
                .el-table__header {
                    thead {
                        .cell {
                            top: -10px;
                        }
                    }
                }
            }
        }
    }
}
</style>
